<template>
    <div class="o-users__controls" :class="`${formCustomClass}`">
        <m-control
            type="text"
            label="Imię"
            placeholder="Imię"
            name="first_name"
            v-model="first_name"
        />
        <m-control
            type="text"
            label="Nazwisko"
            placeholder="Nazwisko"
            name="lastname"
            v-model="last_name"
        />
        <m-control
            type="text"
            label="E-mail"
            placeholder="E-mail"
            name="email"
            v-model="email"
        />
        <m-control
            type="text"
            label="Telefon"
            placeholder="Telefon"
            name="phone"
            v-model="phone"
        />
        <m-control
            type="search"
            label="Powiat"
            placeholder="Powiat"
            name="counties"
            :value="counties"
            :object="true"
            :multiple="true"
            @input="counties = $event"
        />
        <m-tags :value="counties" />
        <m-control
            v-if="!hideDevices"
            type="text"
            label="Ilość urządzeń"
            placeholder="Wpisz ilość urządzeń"
            name="devices_number"
            v-model="devices_number"
        />
    </div>
</template>

<script>
export default {
    props: {
        hideCustomer: {
            type: Boolean,
            default: false
        },
        hideDevices: {
            type: Boolean,
            default: false
        },
        formCustomClass: {
            type: String,
            default: ''
        }
    },
    watch: {
        first_name(value) {
            this.$emit('update:first_name', value)
        },
        last_name(value) {
            this.$emit('update:last_name', value)
        },
        email(value) {
            this.$emit('update:email', value)
        },
        phone(value) {
            this.$emit('update:phone', value)
        },
        counties(value) {
            this.$emit('update:counties', value)
        },
        devices_number(value) {
            this.$emit('update:devices_number', value)
        },
        customer(value) {
            this.$emit('update:customer', value)
        }
    },
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            counties: [],
            devices_number: 1,
            customer: 'customer'
        }
    },
    methods: {
        validateForm() {
            if (this.first_name === '') {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij imię'
                })
                return false
            }
            if (this.last_name === '') {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij nazwisko'
                })
                return false
            }
            if (this.email === '') {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij email'
                })
                return false
            }
            if(!/(.+)@(.+)\.(.+){2,}/.test(this.email)) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij poprawnie adres email'
                })
                return false
            }
            if (this.phone === '') {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij telefon'
                })
                return false
            }
            if (this.counties.length === 0) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij powiat'
                })
                return false
            }

            if (
                !this.hideDevices &&
                (this.devices_number === '' || this.devices_number === '0')
            ) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij ilość urządzeń'
                })
                return false
            }
            return true
        }
    }
}
</script>
